import DropDownButtons from "components/Ui/DropDownButtons/DropDownButtons";
import TableBodyCells from "components/Ui/TableBodyCells/TableBodyCells";

const group = (props) => {
    const cellRenderers = {
        id: () => <td>{props.group?.id}</td>,
        name: () => (
            <td className="name">
                <h6>{props.group?.name}</h6>
            </td>
        ),
        type: () => <td>{props.group?.type === "single" ? "اختيار واحد" : "خيار متعدد"}</td>,
        options: () => (
            <td>
                {props.group?.options?.length > 0
                    ? props.group?.options.map((o) => o.name + " - ")
                    : "لا يوجد"}
            </td>
        ),
        actions: () => (
            <td>
                <DropDownButtons
                    group={props.group}
                    edit={() => {
                        props.setSelectedgroupValue(props.group);
                        props.toggleEditForm();
                    }}
                    delete={() => {
                        props.setSelectedgroupValue(props.group);
                        props.toggleDelete();
                    }}
                ></DropDownButtons>
            </td>
        ),
    };

    return (
        <tr className="item">
            <TableBodyCells visibleColumns={props.visibleColumns} renderers={cellRenderers} />
        </tr>
    );
};

export default group;
